module.exports = __webpack_public_path__ + "assets/img/ps-3.0fb857af.png";